import { Routes } from '@angular/router';
import { MainLayoutComponent } from './layout/main-layout/main-layout.component';
import { authGuard } from './core/guards/auth.guard';
// import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  // Rutas de autenticación (no usan el layout principal)
  {
    path: 'auth',
    loadChildren: () =>
      import('./features/auth/auth.routes').then((m) => m.authRoutes),
  },

  // Rutas protegidas que usan el layout con Navbar y Sidebar
  {
    path: 'app',
    component: MainLayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./features/dashboard/dashboard.component').then(
            (c) => c.DashboardComponent,
          ),
      },
      {
        path: 'gestion',
        loadChildren: () =>
          import('./features/management/managements.routes').then(
            (m) => m.managementRoutes,
          ),
      },
      {
        path: 'inasistencias',
        loadChildren: () =>
          import('./features/absence-management/absence-management.routes').then(
            (m) => m.absenceManagementRoutes,
          ),
      },
      {
        path: 'votes',
        loadChildren: () =>
          import('./features/participation/participation.routes').then(
            (m) => m.votesRoutes,
          ),
      },
      {
        path: 'surveys',
        loadChildren: () =>
          import('./features/participation/participation.routes').then(
            (m) => m.surveysRoutes,
          ),
      },
      {
        path: 'incidents',
        loadChildren: () =>
          import('./features/incidents/incidents.routes').then(
            (m) => m.IncidentsRoutes,
          ),
      },
      {
        path: 'configuration',
        loadChildren: () =>
          import('./features/configuration/configuration.routes').then(
            (m) => m.configuracionRoutes,
          ),
      },
      {
        path: 'communications',
        loadChildren: () =>
          import('./features/comunications/comunications.routes').then(
            (m) => m.comunicationsRoutes,
          ),
      },
      {
        path: 'policies',
        loadChildren: () =>
          import('./features/policies/policies.routes').then(
            (m) => m.policiesRoutes,
          ),
      },
      {
        path: 'deliveries',
        loadChildren: () =>
          import('./features/deliveries/deliveries.routes').then(
            (m) => m.delivetyRoutes,
          ),
      },
      {
        path: 'type-events',
        loadChildren: () =>
          import('./features/type-events/type_events.routes').then(
            (m) => m.TypeEventsRoutes,
          ),
      },
      {
        path: 'tramites-cesado',
        loadChildren: () =>
          import('./features/terminated-employees/terminated-employees.routes').then(
            (m) => m.terminatedEmployeesRoutes,
          ),
      },
      {
        path: 'access-report',
        loadChildren: () =>
          import('./features/access-report/access-report.routes').then(
            (m) => m.accessReportRoutes,
          ),
      },
      {
        path: 'vacation-request',
        loadChildren: () =>
          import('./features/vacation-request/vacation-request.routes').then(
            (m) => m.vacationRequestRoutes,
          ),
      },
      {
        path: 'reports',
        loadChildren: () =>
          import('./features/reports/reports.routes').then(
            (m) => m.reportRoutes,
          ),
      },
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
    ],
  },
  // Ruta pública — sin guard de autenticación
  {
    path: 'terminos-y-condiciones',
    loadComponent: () =>
      import('./features/public/terms-and-conditions/public-terms-and-conditions.component').then(
        (c) => c.PublicTermsAndConditionsComponent,
      ),
  },

  // Redirección por defecto
  {
    path: '',
    redirectTo: 'auth',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: 'app', // Manejo de rutas no encontradas
  },
];
